const toggle = document.querySelector('.menu-toggle');
const mobileNav = document.querySelector('.mobile-nav');
toggle?.addEventListener('click', () => {
  const open = toggle.getAttribute('aria-expanded') !== 'true';
  toggle.setAttribute('aria-expanded', String(open));
  toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  mobileNav.hidden = !open;
});
const dropdownButtons = [...document.querySelectorAll('.nav-dropdown__button')];
for (const button of dropdownButtons) {
  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') !== 'true';
    for (const other of dropdownButtons) {
      const isOpen = other === button && expanded;
      other.setAttribute('aria-expanded', String(isOpen));
      other.parentElement.classList.toggle('is-open', isOpen);
    }
  });
}
document.addEventListener('click', (event) => {
  for (const button of dropdownButtons) {
    if (!button.parentElement.contains(event.target)) {
      button.parentElement.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
    }
  }
});

// Shopify handles delivery and confirmation for the native contact form.
// This enhancement only prepares the owner's direct-contact alternatives.
const form = document.getElementById('rental-form');
if (form) {
  const params = new URLSearchParams(window.location.search);
  const format = form.elements.namedItem('contact[Rental format]');
  const selected = params.get('package');
  if (selected && format && [...format.options].some((option) => option.value === selected)) {
    format.value = selected;
  }
  const emailDraft = document.getElementById('email-draft');
  const whatsappDraft = document.getElementById('whatsapp-draft');
  const fields = [
    ['Name', 'contact[name]'],
    ['Email', 'contact[email]'],
    ['Phone', 'contact[phone]'],
    ['Company', 'contact[Company]'],
    ['Rental format', 'contact[Rental format]'],
    ['Event date', 'contact[Event date]'],
    ['Location', 'contact[Event location]'],
    ['Event type', 'contact[Event type]'],
    ['Guests', 'contact[Estimated guests]'],
    ['Duration', 'contact[Rental duration]'],
    ['Preferred contact', 'contact[Preferred contact method]'],
    ['Notes', 'contact[body]'],
  ];
  const preferences = ['Brand integration', 'Multi-screen setup', 'Motion simulator', 'Competition format'];
  function updateDraft() {
    const data = new FormData(form);
    const lines = ['Simuluxor rental inquiry', ''];
    for (const [label, key] of fields) lines.push(`${label}: ${data.get(key) || 'Not provided'}`);
    lines.push(`Preferences: ${preferences.filter((item) => data.has(`contact[${item}]`)).join(', ') || 'Not specified'}`);
    const message = lines.join('\n');
    emailDraft.href = `mailto:robert@simuluxor.com?subject=${encodeURIComponent('Simuluxor rental inquiry')}&body=${encodeURIComponent(message)}`;
    whatsappDraft.href = `https://wa.me/14164528880?text=${encodeURIComponent(message)}`;
  }
  form.addEventListener('input', updateDraft);
  form.addEventListener('change', updateDraft);
  updateDraft();
}

// The hero keeps its still frame for reduced-motion and data-saving visitors.
const dataSaverOn = navigator.connection?.saveData === true;
const heroVideo = document.querySelector('[data-hero-video]');
if (heroVideo) {
  const heroSource = heroVideo.querySelector('source[data-src]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let heroInView = true;

  function playHeroVideo() {
    if (reducedMotion.matches || dataSaverOn || document.hidden) {
      heroVideo.pause();
      return;
    }
    if (heroVideo.dataset.loaded !== 'true') {
      heroSource.src = window.matchMedia('(max-width:650px)').matches ? heroSource.dataset.mobileSrc : heroSource.dataset.src;
      heroVideo.dataset.loaded = 'true';
      heroVideo.load();
    }
    heroVideo.play().catch(() => {});
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      heroInView = entry.isIntersecting;
      if (heroInView) playHeroVideo();
      else heroVideo.pause();
    }, { threshold: 0.05 });
    observer.observe(heroVideo.closest('.hero'));
  } else {
    playHeroVideo();
  }

  reducedMotion.addEventListener?.('change', () => {
    if (reducedMotion.matches) heroVideo.pause();
    else if (heroInView) playHeroVideo();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) heroVideo.pause();
    else if (heroInView) playHeroVideo();
  });
}

// The second homepage video is decorative; defer its download and playback until needed.
const nightVideo = document.querySelector('[data-night-video]');
if (nightVideo) {
  const nightSection = nightVideo.closest('.intro-section--night');
  const nightSource = nightVideo.querySelector('source[data-src]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function playNightVideo() {
    if (reducedMotion.matches || dataSaverOn || document.hidden) return;
    if (nightVideo.dataset.loaded !== 'true') {
      nightSource.src = nightSource.dataset.src;
      nightVideo.dataset.loaded = 'true';
      nightVideo.load();
    }
    nightVideo.play().catch(() => {});
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) playNightVideo();
      else nightVideo.pause();
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    observer.observe(nightSection);
  } else if (!reducedMotion.matches && !dataSaverOn) {
    playNightVideo();
  }

  reducedMotion.addEventListener?.('change', () => {
    if (reducedMotion.matches) {
      nightVideo.pause();
      return;
    }
    const sectionBounds = nightSection.getBoundingClientRect();
    if (sectionBounds.bottom > 0 && sectionBounds.top < window.innerHeight) playNightVideo();
  });
}

// Shopify's native page paths retain the selected marketing navigation state.
for (const link of document.querySelectorAll('.site-header a.nav-link')) {
  if (link.getAttribute('href') === location.pathname) {
    link.classList.add('is-active');
    link.setAttribute('aria-current', 'page');
  }
}
if (location.pathname.startsWith('/pages/mobile-race-studio') || location.pathname.startsWith('/pages/two-simulators') || location.pathname.startsWith('/pages/single-simulator') || location.pathname === '/pages/race-components' || location.pathname === '/pages/pay-to-race-events') {
  document.querySelector('.desktop-nav .nav-dropdown__button')?.classList.add('is-active');
}
